import {
  Component,
  OnDestroy,
  ElementRef,
  AfterViewInit,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from "@angular/core";
import { BfxBlotterOrdersActionService } from "../bfx-blotter-orders/bfx-blotter-orders-action.service";
import { BfxBaseBlotterColumnSelectorService } from "../bfx-base-blotter/bfx-base-blotter-columnselector.service";

import { BfxBlotterOrdersService } from "../bfx-blotter-orders/bfx-blotter-orders.service";
import { BfxDialogData } from "../bfx-dialogs/models/bfx-dialog-data.model";
import { BfxDialogCommand } from "../bfx-dialogs/models/bfx-dialog-command.enum";
import { GoldenLayoutComponent } from "../golden-layout/golden-layout-component";
import { TranslateService } from "@ngx-translate/core";
import { GoldenLayoutPopout } from "../golden-layout/golden-layout-popout";
import { Subscription } from "rxjs";

import {
  ErrorsImpl,
  OrderState,
  OrderLifeCycleEventImpl,
  OrderLifeCycleEvent,
  FxLifeCycleEventType,
  AcceptanceAction,
  AcceptanceType,
  BulkOrderLifeCycleEventImpl,
  TradingGroupImpl,
  XferType,
} from "shared/cubiq-model-multi-asset";

import * as CubiqTS from "shared/cubiq-model-multi-asset";

import {
  SysFeatures,
  Roles,
  ActiveUser,
  OrderDataActionPromiseService,
  OrderDataPromiseLookupService,
  OrderAcceptancePromiseService,
  SystemConfigPromiseService,
  ActiveUserProfilePromiseService,
  TraderGroupPromiseLookupService,
  COLUMN_DESK_ID,
  COLUMN_ORDER_ERRORS,
  COLUMN_ORDER_STATE,
  OrderDataModelUpdateSource,
  AlgoStrategyLookupService,
  BenchmarkDataPrimaryLookupService,
  HedgeOrderDataPrimaryLookupService,
} from "shared/cubiq-services";
import { GridOptions, ColDef } from "ag-grid-community";
import { LoggerService } from "@bfx/logger";

import { ProgressStatus } from "../bfx-element-library/progress-bar-value.constants";
import { NativeDesktopSupport } from "../bfx-native-desktop/native-desktop-support";
import { BfxColDef } from "shared/cubiq-services/model/TableDefinition";
import { OrderStateHelper } from "shared/cubiq-services/model/orders/OrderStateHelper";

import { BfxConfigIDRefHelper } from "src/shared/helper-services/bfx-config-id-ref-helper";
import { OrderDescriptionHelper } from "shared/cubiq-services/model/orders/OrderDescriptionHelper";
import { BfxSysConfigUtilService } from "shared/auth-services";
import { BmarkOrderData } from "shared/cubiq-services/model/benchmarks/BmarkOrderData.model";
import { BmarkClientOrdersBlotterMode } from "shared/cubiq-services/model/benchmarks/enums/BmarkClientOrdersBlotterMode.enum";
import { BMRiskUtils } from "shared/cubiq-services/model/benchmarks/helpers/BMRiskUtils";
import { BfxInputControlStateEnum } from "shared/base-components/models/base-components.enums";
import { NativeDesktopWindow } from "shared/native-desktop/NativeDesktopWindow";

export const STATUS_FAILED: string = "Failed";
export const MIN_VISIBLE_ROWS: number = 7;

const PENDING_FWD_STATES: Array<OrderState> = [
  OrderState.PENDING_FWDS,
  OrderState.EXPIRY_PENDING_FWDS,
  OrderState.CANCEL_PENDING_FWDS,
];

const TERMINAL_STATES = [CubiqTS.OrderState.FILLED, CubiqTS.OrderState.EXPIRED];

export enum OrderCancelRecordState {
  IN_PROGRESS,
  ACCEPTANCE,
  FAILED,
  ABORT_REJECT,
  CANCELED,
}

export enum OrderCancelType {
  BENCHMARK,
  LIMIT,
}

export class OrderCancelRecord {
  constructor(
    public orderId: string = "",
    public orderRef: string = "",
    public allocationId: string = "",
    public strategyId: any = "",
    public orderDescription: string = "",
    public traderGroupName: string = "",
    public orderStatus: string = "",
    public reason: string = "",
    public externalTraderGroup: boolean = false,
    public externalState: boolean = false,
    public state: OrderCancelRecordState = OrderCancelRecordState.IN_PROGRESS,
    public rawData: any = null,
    public requestType: OrderCancelType = OrderCancelType.LIMIT,
    public positionOrder: boolean = false,
    public pendingForward: boolean = false,
    public orderState: OrderState = null,
  ) {}
}

const logger = LoggerService.for(__dirname);

@Component({
  selector: "bfx-order-cancel",
  templateUrl: "./html/bfx-order-cancel.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BfxOrderCancelComponent implements GoldenLayoutComponent, OnDestroy, AfterViewInit {
  /**
   * An array of all selected orders for cancellation
   */
  public orderRecords: Array<OrderCancelRecord> = [];

  public orderMap: Map<string, OrderCancelRecord[]> = new Map();
  public orderIdAllocationIdMap: Map<string, string[]> = new Map();

  public monitoredStrategyIds = new Set<string>();
  public pendingOrderMap: Map<string, OrderCancelRecord[]> = new Map();
  public pendingDeletionSet: Set<string> = new Set();

  public showClose: boolean = true;
  public showCancel: boolean = true;
  public showAbort: boolean = false;
  public showReject: boolean = false;
  public showAccept: boolean = false;
  public loading: boolean = true;

  public scrollWidth: string = "750px";
  public scrollHeight: string = "180px";
  public commentFocused: boolean = false;
  public mandatoryComment: boolean = true;
  public mandatoryCommentLoaded: boolean = false;
  public comment: string = "";
  public message: string = "";
  public parentPopout: GoldenLayoutPopout = null;
  public progress: number = 0;
  public progressStatus: ProgressStatus = ProgressStatus.WAITING;
  public modelUpdateSubscription: Subscription;
  public modelErrorSubscription: Subscription;
  public modelDeleteSubscription: Subscription;
  public freezeButtonUpdates: boolean = false;

  private subscriptions: Subscription[] = [];

  public canAccept: boolean = false;
  public canReject: boolean = false;
  public traderUnrestricted: boolean = false;
  public activeUser: ActiveUser = null;
  public invalidComment: boolean = null;
  private hasRequestInFlight: boolean = false;

  private scheduledGridRefresh: boolean = false;

  private orderStateHelper: OrderStateHelper;

  public columnDefs: Array<ColDef | BfxColDef> = [];
  public gridOptions: GridOptions;

  private refreshDelay: number = 0;
  public blotterInstance: any = null;
  public viewInitComplete: boolean = false;

  /** Validation state used Text input after  */
  public externalState: BfxInputControlStateEnum = BfxInputControlStateEnum.ACTIVE;

  public control: any = {
    mode: true,
    containerHeight: 324,
    scrollbarConfig: {
      suppressScrollX: true,
    },
  };

  private _orderDescriptionHelper: OrderDescriptionHelper;

  constructor(
    protected columnSelectorService: BfxBaseBlotterColumnSelectorService,
    public orderActionService: OrderDataActionPromiseService,
    public orderAcceptService: OrderAcceptancePromiseService,
    public orderBlotterService: BfxBlotterOrdersService,
    public sysConfigService: SystemConfigPromiseService,
    public orderDataService: OrderDataPromiseLookupService,
    private tradeGroupService: TraderGroupPromiseLookupService,
    private algoStrategyLookupService: AlgoStrategyLookupService,
    public activeUserService: ActiveUserProfilePromiseService,
    public systemConfigService: SystemConfigPromiseService,
    public blotterOrderActionService: BfxBlotterOrdersActionService,
    public benchmarkOrderService: BenchmarkDataPrimaryLookupService,
    public hedgeOrderService: HedgeOrderDataPrimaryLookupService,
    public element: ElementRef,
    public translationService: TranslateService,
    private sysConfigUtil: BfxSysConfigUtilService,
    private cd: ChangeDetectorRef,
  ) {
    this.blotterInstance = this;
    this.initialize();
  }

  protected initialize(): void {
    this._orderDescriptionHelper = new OrderDescriptionHelper(
      this.tradeGroupService,
      this.algoStrategyLookupService,
      this.sysConfigUtil,
    );
    this.orderStateHelper = new OrderStateHelper(COLUMN_ORDER_STATE, this.translationService);

    this.gridOptions = <GridOptions>{
      deltaRowDataMode: true,
      getRowNodeId: (data) => {
        if (data) return String(data["orderId"]);
        return "";
      },
      suppressContextMenu: true,
      headerHeight: 24,
      suppressColumnMoveAnimation: true,
      suppressDragLeaveHidesColumns: true,
      suppressScrollOnNewData: true,
      suppressFocusAfterRefresh: true,
      suppressAutoSize: true,
      showToolPanel: false,
      toolPanelSuppressSideButtons: true,
      enableFilter: true,
      rowDeselection: true,
      enableBrowserTooltips: true,
      onGridReady: (_) => {
        this.gridOptions.api.setRowData(this.orderRecords);
      },
      onGridSizeChanged: (_) => {},
    };
    // Column defs common(ish) with Cancel/Take/Force Take/Transfer/Pause
    this.columnDefs = [
      {
        headerName: "Order ID",
        field: "orderRef",
        editable: false,
        colId: "orderId",
        suppressMenu: true,
        omitFromPicker: false,
        hide: false,
        minWidth: 80,
        width: 125,
      },
      {
        headerName: "Order",
        field: "orderDescription",
        editable: false,
        colId: "order",
        suppressMenu: true,
        omitFromPicker: false,
        disableInPicker: true,
        hide: false,
        minWidth: 250,
        width: 350,
      },
      {
        headerName: "Trader Group",
        field: "traderGroupName",
        editable: false,
        colId: "traderGroupName",
        suppressMenu: true,
        omitFromPicker: false,
        disableInPicker: true,
        hide: false,
        minWidth: 90,
        width: 110,
      },
      {
        headerName: "Status",
        field: "orderStatus",
        editable: false,
        colId: "orderStatus",
        suppressMenu: true,
        omitFromPicker: false,
        disableInPicker: true,
        hide: false,
        minWidth: 90,
        width: 110,
      },
      {
        headerName: "Reason",
        field: "reason",
        editable: false,
        colId: "reason",
        suppressMenu: true,
        omitFromPicker: false,
        disableInPicker: true,
        hide: false,
        minWidth: 250,
        width: 350,
      },
    ];
    NativeDesktopSupport.prepareGridOptions(this.gridOptions, this.element.nativeElement);

    this.sysConfigService
      .getSystemConfig(SysFeatures.mandatoryCancelCommentsEnabled)
      .then((value: string) => {
        this.mandatoryComment = value == null || value == "Y";
        this.mandatoryCommentLoaded = true;
      });

    this.systemConfigService.hasRole(Roles.DI_TRADER_ACCEPT).then((value: boolean) => {
      this.canAccept = value;
    });

    this.systemConfigService.hasRole(Roles.DI_TRADER_REJECT).then((value: boolean) => {
      this.canReject = value;
    });

    this.systemConfigService.hasRole(Roles.DI_TRADER_UNRESTRICTED).then((value: boolean) => {
      this.traderUnrestricted = value;
    });

    this.activeUserService.getActiveUserData().then((data: ActiveUser) => {
      this.activeUser = data;
    });
  }

  ngOnDestroy() {
    this.viewInitComplete = false;

    this.subscriptions.forEach((subscription: Subscription, index: number) => {
      try {
        subscription.unsubscribe();
      } catch (e) {
        logger.out.warn("Failed to unsubscribe from a cancel subscription at index " + index);
      }
    });

    this.orderMap = null;
    this.orderIdAllocationIdMap = null;
    this.blotterInstance = null;
  }

  ngAfterViewInit() {
    this.viewInitComplete = true;
  }

  glInit(data: any, _container: any, _state: any): void {
    Promise.all([this.orderBlotterService.isReady(), this.sysConfigService.isPrimed()]).then(() => {
      // Get all the other orders in the strategies and append them
      const orders: Array<any> = data;
      const relatedOrders = this.findRelatedOrders(orders);
      const allOrders = orders.concat(relatedOrders);

      this.orderRecords = this.createOrderRecords(allOrders, false);
      let orderCount = this.orderRecords.length;
      if (orderCount >= 500) {
        this.refreshDelay = 500;
      } else if (orderCount >= 100) {
        this.refreshDelay = 100;
      } else if (orderCount >= 50) {
        this.refreshDelay = 50;
      }

      this.orderRecords.forEach((record: OrderCancelRecord) => {
        if (this.orderMap.has(record.orderId))
          this.orderMap.set(record.orderId, [...this.orderMap.get(record.orderId), record]);
        else this.orderMap.set(record.orderId, [record]);
      });

      this.modelUpdateSubscription = this.orderDataService
        .getModelUpdateSubject()
        .subscribe(this.onModelUpdated.bind(this));
      this.modelErrorSubscription = this.orderDataService
        .getModelErrorSubject()
        .subscribe(this.onModelErrors.bind(this));

      let benchmarkClientOrderSubscription: Subscription = this.benchmarkOrderService
        .getModelUpdateSubject()
        .asObservable()
        .subscribe((modelUpdate) => {
          // logger.out.warn(`${this.constructor.name}.benchmarkOrderService modelUpdate:%O`, modelUpdate);
          this.onModelUpdated(modelUpdate);
        });

      let benchmarkHedgeOrderSubscription: Subscription = this.hedgeOrderService
        .getModelUpdateSubject()
        .asObservable()
        .subscribe((modelUpdate) => {
          logger.out.warn(`${this.constructor.name}.hedgeOrderService modelUpdate:%O`, modelUpdate);
          this.onModelUpdated(modelUpdate);
        });

      let benchmarkClientInterventionSubscription: Subscription = this.benchmarkOrderService
        .getInterventionEventObservable()
        .subscribe((event: CubiqTS.InterventionEventImpl) => {
          if (event != null && event.orderData != null && event.orderData.orderId != null) {
            let orderId = event.orderData.orderId.toString();
            let orderRecords: Array<OrderCancelRecord> = this.orderMap.has(orderId)
              ? this.orderMap.get(orderId)
              : [];
            let refresh: boolean = false;

            orderRecords.forEach((orderRecord) => {
              if (
                orderRecord.orderId === event.orderData.orderId.toString() &&
                event.errors instanceof CubiqTS.ErrorsImpl &&
                Array.isArray(event.errors.errorMessages) &&
                event.errors.errorMessages.length > 0
              ) {
                orderRecord.reason = this.convertError(event.errors);
                refresh = true;
              }
            });

            if (refresh) {
              this.scheduleRefresh();
            }
          }
        });

      let benchmarkHedgeInterventionSubscription: Subscription = this.hedgeOrderService
        .getInterventionEventObservable()
        .subscribe((event: CubiqTS.InterventionEventImpl) => {
          if (event != null && event.orderData != null && event.orderData.orderId != null) {
            let orderId = event.orderData.orderId.toString();
            let orderRecords: Array<OrderCancelRecord> = this.orderMap.has(orderId)
              ? this.orderMap.get(orderId)
              : [];
            let refresh: boolean = false;

            orderRecords.forEach((orderRecord) => {
              if (
                orderRecord.orderId === event.orderData.orderId.toString() &&
                event.errors instanceof CubiqTS.ErrorsImpl &&
                Array.isArray(event.errors.errorMessages) &&
                event.errors.errorMessages.length > 0
              ) {
                orderRecord.reason = this.convertError(event.errors);
                refresh = true;
              }
            });

            if (refresh) {
              this.scheduleRefresh();
            }
          }
        });

      this.modelDeleteSubscription = this.orderDataService
        .getModelDeleteSubject()
        .subscribe(this.onModelDeleted.bind(this));

      this.subscriptions = [
        this.modelUpdateSubscription,
        this.modelDeleteSubscription,
        this.modelErrorSubscription,
        benchmarkClientOrderSubscription,
        benchmarkHedgeOrderSubscription,
        benchmarkClientInterventionSubscription,
        benchmarkHedgeInterventionSubscription,
      ];

      this.tradeGroupService.getAll().then((value: TradingGroupImpl[]) => {
        let externalTraderGroupIds = new Set(
          value
            .filter((traderGroup: TradingGroupImpl) => traderGroup.isExternallyFilledFg)
            .map((traderGroup: TradingGroupImpl) => traderGroup.groupId.toString()),
        );

        this.orderRecords.forEach((orderRecord: OrderCancelRecord) => {
          let traderGroupId =
            orderRecord.rawData[COLUMN_DESK_ID] instanceof CubiqTS.Long
              ? orderRecord.rawData[COLUMN_DESK_ID].toString()
              : null;

          orderRecord.externalTraderGroup = externalTraderGroupIds.has(traderGroupId);
        });
      });
    });
  }

  /**
   * Get all related orders for both limit strategies and spawned BM orders
   * @param rows
   * @returns
   */
  protected findRelatedOrders(rows: Array<any>) {
    const bmarks: BmarkOrderData[] = [];
    const limits: CubiqTS.OrderData[] = [];
    for (let order of rows) {
      if (order instanceof BmarkOrderData) {
        bmarks.push(order);
      } else {
        limits.push(order);
      }
    }

    const relatedBMOrders = this.findRelatedBMOrders(bmarks);
    const relatedLimitOrders = this.findRelatedLimitOrders(limits);

    return relatedBMOrders.concat(relatedLimitOrders);
  }

  /**
   * For every BMarkOrderData, we check to see if the order is spawned and being viewed in Risk mode. If so,
   * we get the source order, and add all missing risk allocations (as orders)
   * @param orders
   * @returns
   */
  private findRelatedBMOrders(orders: BmarkOrderData[]): CubiqTS.OrderData[] {
    const retOrders: BmarkOrderData[] = [];

    if (!orders || orders.length == 0) {
      return retOrders;
    }

    const existingRiskMap: any = {};
    const spawnedOrders = [];
    orders.forEach((order: BmarkOrderData) => {
      if (order.spawned && order.blotterMode === BmarkClientOrdersBlotterMode.RISK) {
        spawnedOrders.push(order);
        let riskID = order?.allocationData[0]?.riskId.toString();
        // Mark the input risk as already process so won't be added
        if (riskID) {
          existingRiskMap[riskID] = true;
        }
      }
    });

    // Now we have all risks explicitly being cancelled and list of spawned orders - next, get
    // any missing risk legs
    spawnedOrders.forEach((order: BmarkOrderData) => {
      const sourceAllocations = order?.source?.allocationData;
      if (sourceAllocations && sourceAllocations.length) {
        const riskMap = BMRiskUtils.createRiskMap(sourceAllocations);
        for (let risk of riskMap.values()) {
          // RiskMap will have Direct plus 2 component - just take the component that we haven't seen
          if (!risk.isDealt && !existingRiskMap[risk.riskId]) {
            const orderData = new BmarkOrderData(order);
            orderData.allocationData = risk.allocations;
            retOrders.push(orderData);
          }
        }
      }
    });

    return retOrders;
  }

  private findRelatedLimitOrders(limits: CubiqTS.OrderData[]): CubiqTS.OrderData[] {
    if (!limits || limits.length == 0) {
      return [];
    }
    return this.orderBlotterService.findRelatedOrders(limits);
  }

  protected onModelUpdated(event: any): void {
    if (!event) {
      return;
    }
    this.updateOrderState(event);
    // Exclude Part filled events as they can arrive at any time and are not generated
    // as result of any cancel operation
    const eventTypeExcluded =
      event.evtTypeId != null &&
      (event.evtTypeId === FxLifeCycleEventType.CREDIT_UPDATE ||
        event.evtTypeId === FxLifeCycleEventType.FILLED_PARTIAL);
    if (
      this.progressStatus !== ProgressStatus.WAITING &&
      event.source === OrderDataModelUpdateSource.OrderLifeCycleEvent &&
      (!eventTypeExcluded || PENDING_FWD_STATES.includes(event.orderState))
    ) {
      if (!this.isLockEvent(event)) {
        let orderId: string = event.orderId.toString();
        let orderRecords: Array<OrderCancelRecord> = this.orderMap.has(orderId)
          ? this.orderMap.get(orderId)
          : [];

        orderRecords.forEach((record) => {
          record.orderStatus = this.orderStateHelper.getState({ data: event });
          if (
            OrderState.CANCELLED !== event.orderState &&
            OrderState.CANCEL_PENDING_FWDS !== event.orderState &&
            Array.isArray(event?.orderErrors?.errorMessages) &&
            event.orderErrors.errorMessages.length > 0
          ) {
            record.reason = this.convertError(event.orderErrors);
          } else {
            record.reason = "";
          }

          record.rawData = event;

          record.pendingForward = PENDING_FWD_STATES.includes(event.orderState);

          if (
            OrderState.EXT_ACCEPTANCE_NEEDED === event.orderState ||
            OrderState.EXT_CANCEL_ACCEPTANCE_NEEDED === event.orderState ||
            OrderState.EXT_MODIFY_ACCEPTANCE_NEEDED === event.orderState
          ) {
            record.externalState = true;
          } else {
            record.externalState = false;
          }

          if (
            event.orderState != OrderState.CANCELLED &&
            event.orderState != OrderState.CANCEL_PENDING_FWDS &&
            event.orderState != OrderState.CANCEL_ACCEPTANCE_NEEDED &&
            event.orderState != OrderState.EXT_CANCEL_ACCEPTANCE_NEEDED &&
            event.xferEventType != XferType.XFER_CANCEL
          ) {
            record.state = OrderCancelRecordState.ABORT_REJECT;
          } else if (
            event.orderState == OrderState.CANCEL_ACCEPTANCE_NEEDED ||
            event.orderState == OrderState.EXT_CANCEL_ACCEPTANCE_NEEDED
          ) {
            // an update in these states resets button availablity
            this.hasRequestInFlight = false;
            record.state = OrderCancelRecordState.ACCEPTANCE;
          } else if (
            event.orderState == OrderState.CANCELLED ||
            event.orderState == OrderState.CANCEL_PENDING_FWDS
          ) {
            this.onModelDeleted(orderId);
          }
        });
        this.scheduleRefresh();
      }
    } else if (
      event != null &&
      this.progressStatus !== ProgressStatus.WAITING &&
      (event.source === OrderDataModelUpdateSource.OrderLifeCycleEvent ||
        event.source === OrderDataModelUpdateSource.BulkOrderLifeCycleEvent) &&
      (event.orderState === OrderState.CANCELLED ||
        event.orderState === OrderState.EXPIRED ||
        event.orderState === OrderState.FILLED ||
        event.orderState === OrderState.DELETED ||
        event.orderState === OrderState.ABORTED) &&
      event.orderId.toString != null
    ) {
      this.onModelDeleted(event.orderId.toString());
    } else if (this.progressStatus !== ProgressStatus.WAITING) {
      logger.out.info(
        `ordcan-c Event with type ${event.evtTypeId} excluded from cancel processing`,
      );
    }
  }

  updateOrderState(event: any) {
    let orderId: string = event.orderId.toString();
    let orderRecords: Array<OrderCancelRecord> = this.orderMap.has(orderId)
      ? this.orderMap.get(orderId)
      : [];

    if (orderRecords.length === 0 && this.monitoredStrategyIds.has(event.strategyId?.toString())) {
      orderRecords = this.createOrderRecords([event], false);
      this.pendingOrderMap.set(event.orderId.toString(), orderRecords);
      return;
    }

    orderRecords.forEach((orderRecord) => {
      if (orderRecord.orderState !== event?.orderState) {
        orderRecord.orderState = event?.orderState;
      }

      if (TERMINAL_STATES.includes(orderRecord.orderState)) {
        this.pendingDeletionSet.add(orderRecord.orderId);
      } else {
        this.pendingDeletionSet.delete(orderRecord.orderId);
      }
    });
  }

  protected onModelErrors(event: any): void {
    this.handleOrderLifyeCycleErrorEvents([event]);
  }

  protected scheduleRefresh(): void {
    if (!this.scheduledGridRefresh) {
      this.scheduledGridRefresh = true;

      setTimeout(() => {
        if (this.gridOptions && this.gridOptions.api) {
          this.gridOptions.api.refreshCells({
            columns: ["orderStatus", "reason"],
          });
        }
        this.determineActions();
        this.scheduledGridRefresh = false;
      }, this.refreshDelay);
    }
    this.cd.markForCheck();
  }

  protected onModelDeleted(orderId: string): void {
    if (this.progressStatus != ProgressStatus.WAITING) {
      this.doDeletion(orderId);
      this.determineActions();

      if (this.orderMap.size == 0) {
        this.progressStatus = ProgressStatus.SUCCESS;
        this.hideAllActionButtons();
        this.showClose = true;
      }
      this.scheduleRefresh();
    } else {
      this.pendingDeletionSet.add(orderId);
    }
  }

  private doDeletion(id: string): void {
    let orderRecords: Array<OrderCancelRecord> = this.orderMap.has(id) ? this.orderMap.get(id) : [];

    orderRecords.forEach((record) => {
      let total: number = this.orderRecords.length;
      if (OrderCancelRecordState.FAILED != record.state) {
        // if it was failed - leave ti that way - as we have no other info here.
        // otherwise treat it as an external cancel
        if (record.orderState == CubiqTS.OrderState.EXPIRED) {
          record.state = OrderCancelRecordState.FAILED;
          record.orderStatus = record.pendingForward ? "Expired Forward Pending" : "Expired";
          record.reason = this.translationService.instant("order.notCancellable", [
            id,
            record.orderStatus,
          ]);
        } else if (record.orderState == CubiqTS.OrderState.FILLED) {
          record.state = OrderCancelRecordState.FAILED;
          record.orderStatus = "Filled";
          record.reason = this.translationService.instant("order.notCancellable", [
            id,
            record.orderStatus,
          ]);
        } else {
          record.state = OrderCancelRecordState.CANCELED;
          record.orderStatus = record.pendingForward ? "Cancelled Forward Pending" : "Cancelled";
          record.reason = "";
        }
        this.progress += 100 / total;
      }
      this.orderMap.delete(id);
    });
  }

  protected isLockEvent(row: CubiqTS.OrderDataImpl) {
    // This needs to be replaced by the order data lookup service propagating a property inside the raw data
    // depicting the event that is the source for the model update event
    return (
      row.orderState != OrderState.CANCEL_ACCEPTANCE_NEEDED &&
      row.lockType == CubiqTS.LockType.CANCEL_LOCK
    );
  }

  protected determineActions(): void {
    if (!this.freezeButtonUpdates && this.progressStatus == ProgressStatus.RUNNING) {
      this.hideAllActionButtons();

      let acceptanceRecords: Array<OrderCancelRecord> = [];
      let failedRecordsCount: number = 0;
      let rejectRecordsCount: number = 0;
      let cancelledRecordCount: number = 0;
      let inProgressCount: number = 0;
      let ignoredRecordCount: number = 0;
      let anyInternal: boolean = false;

      this.orderRecords.forEach((record: OrderCancelRecord) => {
        if (record.state == OrderCancelRecordState.ACCEPTANCE) {
          acceptanceRecords.push(record);
          anyInternal = anyInternal || !(record.externalTraderGroup && record.externalState);
        } else if (record.state == OrderCancelRecordState.FAILED) {
          failedRecordsCount++;
        } else if (record.state == OrderCancelRecordState.ABORT_REJECT) {
          rejectRecordsCount++;
        } else if (record.state == OrderCancelRecordState.CANCELED) {
          cancelledRecordCount++;
        } else if (TERMINAL_STATES.includes(record.orderState)) {
          ignoredRecordCount++;
        } else if (record.state == OrderCancelRecordState.IN_PROGRESS) {
          inProgressCount++;
        }
      });

      let isInProgress: boolean = inProgressCount != 0;
      let hasAcceptance: boolean = acceptanceRecords.length > 0;

      if (!isInProgress) {
        if (hasAcceptance && !this.hasRequestInFlight) {
          if (this.traderUnrestricted) {
            this.showAccept = true;
            this.showReject = true;
          } else {
            let ownsEvery: boolean = acceptanceRecords.every((record: OrderCancelRecord) => {
              let traderGroupId: string = (record.rawData as CubiqTS.OrderData)?.deskId?.toString();
              return (
                record.state != OrderCancelRecordState.ACCEPTANCE ||
                this.activeUser.tradingGroupsIds.includes(traderGroupId)
              );
            });

            this.showAccept = this.canAccept && ownsEvery;
            this.showReject = this.canReject && ownsEvery;
          }

          this.showAbort = anyInternal;
        } else {
          this.showAbort = false;
          this.showAccept = false;
          this.showReject = false;
        }
      }

      let finishedCount: number =
        failedRecordsCount + cancelledRecordCount + rejectRecordsCount + ignoredRecordCount;
      this.progress =
        (this.orderRecords.length - inProgressCount) * (100 / this.orderRecords.length);

      let allFinished: boolean = finishedCount == this.orderRecords.length;
      if (allFinished) {
        // logger.out.info("(determineActions) cancel complete");
        if (cancelledRecordCount == this.orderRecords.length) {
          this.success();
        } else if (failedRecordsCount > 0) {
          this.fail(failedRecordsCount);
        } else if (rejectRecordsCount > 0) {
          this.fail(
            rejectRecordsCount,
            rejectRecordsCount == 1 ? "cancel.reject.single" : "cancel.reject.multi",
          );
        }
      }
    }
    this.cd.markForCheck();
  }

  public abort(): void {
    this.hasRequestInFlight = true;
    this.hideAllActionButtons();
    let stratMap: Map<string, string> = new Map();

    let limitOrderIds: Array<string> = this.orderRecords
      .filter((record: OrderCancelRecord) => {
        if (
          record.state == OrderCancelRecordState.ACCEPTANCE &&
          !(record.externalTraderGroup && record.externalState) &&
          record.requestType == OrderCancelType.LIMIT
        ) {
          record.state = OrderCancelRecordState.IN_PROGRESS;
          if (!stratMap.get(record.strategyId)) {
            stratMap.set(record.strategyId, record.orderId);
            return true;
          } else {
            return false;
          }
        }
        return false;
      })
      .map((record: OrderCancelRecord) => record.orderId);

    let fixingOrderIds: Array<string> = this.orderRecords
      .filter((record: OrderCancelRecord) => {
        if (
          record.state == OrderCancelRecordState.ACCEPTANCE &&
          !(record.externalTraderGroup && record.externalState) &&
          record.requestType == OrderCancelType.BENCHMARK &&
          !record.positionOrder
        ) {
          record.state = OrderCancelRecordState.IN_PROGRESS;
          if (!stratMap.get(record.strategyId)) {
            stratMap.set(record.strategyId, record.orderId);
            return true;
          } else {
            return false;
          }
        }
        return false;
      })
      .map((record: OrderCancelRecord) => record.orderId);

    let positionOrderIds: Array<string> = this.orderRecords
      .filter((record: OrderCancelRecord) => {
        if (
          record.state == OrderCancelRecordState.ACCEPTANCE &&
          !(record.externalTraderGroup && record.externalState) &&
          record.requestType == OrderCancelType.BENCHMARK &&
          record.positionOrder === true
        ) {
          record.state = OrderCancelRecordState.IN_PROGRESS;
          if (!stratMap.get(record.strategyId)) {
            stratMap.set(record.strategyId, record.orderId);
            return true;
          } else {
            return false;
          }
        }
        return false;
      })
      .map((record: OrderCancelRecord) => record.orderId);

    const resultPromises = [];
    if (limitOrderIds != null && limitOrderIds.length > 0) {
      const resultPromise = this.orderAcceptService.requestAcceptance(
        limitOrderIds,
        "",
        AcceptanceAction.ABORT,
        AcceptanceType.CANCEL,
      );
      resultPromises.push(resultPromise);
    }

    if (fixingOrderIds != null && fixingOrderIds.length > 0) {
      const resultPromise = this.orderAcceptService.requestAcceptance(
        fixingOrderIds,
        "",
        AcceptanceAction.ABORT,
        AcceptanceType.CANCEL,
        null,
        null,
        CubiqTS.OrderType.BENCHMARK,
      );
      resultPromises.push(resultPromise);
    }

    if (positionOrderIds != null && positionOrderIds.length > 0) {
      const resultPromise = this.orderAcceptService.requestAcceptance(
        positionOrderIds,
        "",
        AcceptanceAction.ABORT,
        AcceptanceType.CANCEL,
        null,
        null,
        CubiqTS.OrderType.BENCHMARK,
        CubiqTS.BenchmarkOrderType.PositionOrder,
      );
      resultPromises.push(resultPromise);
    }

    Promise.all(resultPromises).then((results) => this.processAbortErrors(results));
  }

  /**
   * If Abort fails, we need to figure out what has failed, and reset those orders back into acceptance.
   * @param results
   */
  processAbortErrors(results: any[]): any {
    // The results will be array of optional outputs from Limits + BMs + positions - each of these will be an array of batch results
    // i.e. [ [limit batch results], [fixing batch results], [position batch results]]
    // we can flatten into single
    const flatResults = results.flat();

    // Each batch of orders aborted will have a single error, if there was a prob
    const errors = flatResults.filter((result) => result instanceof ErrorsImpl);
    if (errors.length) {
      let orderIds = [];
      errors.forEach((error) => {
        if (error["orderIds"]?.length > 0) {
          const errorIds: string[] = error["orderIds"];
          errorIds.forEach((orderId) => {
            // Reset each Record back to an Order State of ACCEPTANCE
            const cancelRecords = this.orderMap.get(orderId);
            cancelRecords?.forEach(
              (cancelRecord) => (cancelRecord.state = OrderCancelRecordState.ACCEPTANCE),
            );
            orderIds.push(orderId);
          });
        }
      });
      if (orderIds.length) {
        this.hasRequestInFlight = false;
        this.determineActions();
      }
    }
  }

  public accept(): void {
    this.hasRequestInFlight = true;
    this.hideAllActionButtons();

    let ordersExternal: Array<OrderCancelRecord> = this.orderRecords.filter(
      (record: OrderCancelRecord) =>
        record.state == OrderCancelRecordState.ACCEPTANCE &&
        record.externalTraderGroup &&
        record.externalState,
    );
    let externalCount: number = ordersExternal.length;

    if (externalCount > 0) {
      let msg: string =
        externalCount == 1 ? "cancel.order.external.single" : "cancel.order.external.multi";
      let args: Array<any> = externalCount == 1 ? [ordersExternal[0].orderId] : [externalCount];
      let payload: any = {
        messages: [this.translationService.instant(msg, args)],
        title: "cancel.order.external.title",
        callback: this.onAccept.bind(this),
        callbackNegative: () => {
          this.hasRequestInFlight = false;
          this.determineActions();
        },
      };
      this.openConfirmDialog(payload);
      this.determineActions();
    } else {
      this.onAccept();
    }
  }

  protected onAccept(): void {
    let stratMap: Map<string, string> = new Map();
    let limitOrderIds: Array<string> = this.orderRecords
      .filter((record: OrderCancelRecord) => {
        if (
          record.state == OrderCancelRecordState.ACCEPTANCE &&
          record.requestType == OrderCancelType.LIMIT
        ) {
          if (!stratMap.get(record.strategyId)) {
            stratMap.set(record.strategyId, record.orderId);
            return true;
          } else {
            return false;
          }
        }
        return false;
      })
      .map((value: OrderCancelRecord) => {
        value.state = OrderCancelRecordState.IN_PROGRESS;
        return value.orderId;
      });

    let fixingOrderIds: Array<string> = this.orderRecords
      .filter((record: OrderCancelRecord) => {
        if (
          record.state == OrderCancelRecordState.ACCEPTANCE &&
          record.requestType == OrderCancelType.BENCHMARK &&
          !record.positionOrder
        ) {
          if (!stratMap.get(record.strategyId)) {
            stratMap.set(record.strategyId, record.orderId);
            return true;
          } else {
            return false;
          }
        }
        return false;
      })
      .map((value: OrderCancelRecord) => {
        value.state = OrderCancelRecordState.IN_PROGRESS;
        return value.orderId;
      });

    let positionOrderIds: Array<string> = this.orderRecords
      .filter((record: OrderCancelRecord) => {
        if (
          record.state == OrderCancelRecordState.ACCEPTANCE &&
          record.requestType == OrderCancelType.BENCHMARK &&
          record.positionOrder === true
        ) {
          if (!stratMap.get(record.strategyId)) {
            stratMap.set(record.strategyId, record.orderId);
            return true;
          } else {
            return false;
          }
        }
        return false;
      })
      .map((value: OrderCancelRecord) => {
        value.state = OrderCancelRecordState.IN_PROGRESS;
        return value.orderId;
      });

    if (limitOrderIds != null && limitOrderIds.length > 0) {
      this.orderAcceptService.requestAcceptance(
        limitOrderIds,
        this.comment,
        AcceptanceAction.ACCEPT,
        AcceptanceType.CANCEL,
      );
    }

    if (fixingOrderIds != null && fixingOrderIds.length > 0) {
      this.orderAcceptService.requestAcceptance(
        fixingOrderIds,
        this.comment,
        AcceptanceAction.ACCEPT,
        AcceptanceType.CANCEL,
        null,
        null,
        CubiqTS.OrderType.BENCHMARK,
      );
    }

    if (positionOrderIds != null && positionOrderIds.length > 0) {
      this.orderAcceptService.requestAcceptance(
        positionOrderIds,
        this.comment,
        AcceptanceAction.ACCEPT,
        AcceptanceType.CANCEL,
        null,
        null,
        CubiqTS.OrderType.BENCHMARK,
        CubiqTS.BenchmarkOrderType.PositionOrder,
      );
    }
  }

  public reject(): void {
    this.hasRequestInFlight = true;
    this.hideAllActionButtons();

    let ordersExternal: Array<OrderCancelRecord> = this.orderRecords.filter(
      (record: OrderCancelRecord) =>
        record.state == OrderCancelRecordState.ACCEPTANCE &&
        record.externalTraderGroup &&
        record.externalState,
    );
    let externalCount: number = ordersExternal.length;

    if (externalCount > 0) {
      let msg: string =
        externalCount == 1 ? "cancel.order.external.single" : "cancel.order.external.multi";
      let args: Array<any> = externalCount == 1 ? [ordersExternal[0].orderId] : [externalCount];
      let payload: any = {
        messages: [this.translationService.instant(msg, args)],
        title: "cancel.order.external.title",
        callback: this.onReject.bind(this),
        callbackNegative: () => {
          this.hasRequestInFlight = false;
          this.determineActions();
        },
      };
      this.openConfirmDialog(payload);
      this.determineActions();
    } else {
      this.onReject();
    }
  }

  public onReject(): void {
    let stratMap: Map<string, string> = new Map();
    let limitOrderIds: Array<string> = this.orderRecords
      .filter((record: OrderCancelRecord) => {
        if (
          record.state == OrderCancelRecordState.ACCEPTANCE &&
          record.requestType == OrderCancelType.LIMIT
        ) {
          record.state = OrderCancelRecordState.IN_PROGRESS;
          if (!stratMap.get(record.strategyId)) {
            stratMap.set(record.strategyId, record.orderId);
            return true;
          } else {
            return false;
          }
        }
        return false;
      })
      .map((value: OrderCancelRecord) => value.orderId);

    let fixingOrderIds: Array<string> = this.orderRecords
      .filter((record: OrderCancelRecord) => {
        if (
          record.state == OrderCancelRecordState.ACCEPTANCE &&
          record.requestType == OrderCancelType.BENCHMARK &&
          !record.positionOrder
        ) {
          record.state = OrderCancelRecordState.IN_PROGRESS;
          if (!stratMap.get(record.strategyId)) {
            stratMap.set(record.strategyId, record.orderId);
            return true;
          } else {
            return false;
          }
        }
        return false;
      })
      .map((value: OrderCancelRecord) => value.orderId);

    let positionOrderIds: Array<string> = this.orderRecords
      .filter((record: OrderCancelRecord) => {
        if (
          record.state == OrderCancelRecordState.ACCEPTANCE &&
          record.requestType == OrderCancelType.BENCHMARK &&
          record.positionOrder === true
        ) {
          record.state = OrderCancelRecordState.IN_PROGRESS;
          if (!stratMap.get(record.strategyId)) {
            stratMap.set(record.strategyId, record.orderId);
            return true;
          } else {
            return false;
          }
        }
        return false;
      })
      .map((value: OrderCancelRecord) => value.orderId);

    if (limitOrderIds != null && limitOrderIds.length > 0) {
      this.orderAcceptService.requestAcceptance(
        limitOrderIds,
        this.comment,
        AcceptanceAction.REJECT,
        AcceptanceType.CANCEL,
      );
    }

    if (fixingOrderIds != null && fixingOrderIds.length > 0) {
      this.orderAcceptService.requestAcceptance(
        fixingOrderIds,
        this.comment,
        AcceptanceAction.REJECT,
        AcceptanceType.CANCEL,
        null,
        null,
        CubiqTS.OrderType.BENCHMARK,
      );
    }

    if (positionOrderIds != null && positionOrderIds.length > 0) {
      this.orderAcceptService.requestAcceptance(
        positionOrderIds,
        this.comment,
        AcceptanceAction.REJECT,
        AcceptanceType.CANCEL,
        null,
        null,
        CubiqTS.OrderType.BENCHMARK,
        CubiqTS.BenchmarkOrderType.PositionOrder,
      );
    }
  }

  /**
   * Create order cancel records for the table in this dialog
   * from the adapter row data
   * @param rows raw data rows as adapted in the cubiq services
   * @param withReason should reason be included in the record data
   */
  protected createOrderRecords(
    rows: Array<any>,
    withReason: boolean = true,
  ): Array<OrderCancelRecord> {
    return rows.map((row: any) => this.createOrderRecord(row, withReason));
  }

  /**
   * Creates a order cancel record from raw adapter order data records,
   * formulating the order info, trader group name, any reasons if
   * available
   * @param row the raw order data record
   * @param withReason should the reason be included in the record data
   */
  protected createOrderRecord(
    row: CubiqTS.OrderData,
    withReason: boolean = true,
  ): OrderCancelRecord {
    let orderRecord: OrderCancelRecord = new OrderCancelRecord();

    orderRecord.orderId = row.orderId.toString();
    orderRecord.orderRef = BfxConfigIDRefHelper.getOrderRef(row);

    if (
      Array.isArray(row.allocationData) &&
      row.allocationData[0] instanceof CubiqTS.AllocationDataImpl
    )
      orderRecord.allocationId = row.allocationData[0].allocationId
        ? row.allocationData[0].allocationId.toString()
        : null;
    else orderRecord.allocationId = null;

    if (row.strategyId) {
      orderRecord.strategyId = row.strategyId.toString();
      this.monitoredStrategyIds.add(row.strategyId.toString());
    } else {
      orderRecord.strategyId = row.orderId.toString();
    }

    orderRecord.orderDescription = this._orderDescriptionHelper.createOrderDescription(row);
    orderRecord.orderStatus = "";
    orderRecord.orderState = row.orderState;
    orderRecord.traderGroupName = this._orderDescriptionHelper.createTraderGroupDescription(
      row,
      true,
    );
    orderRecord.rawData = row;

    if (
      OrderState.EXT_ACCEPTANCE_NEEDED === row.orderState ||
      OrderState.EXT_CANCEL_ACCEPTANCE_NEEDED === row.orderState ||
      OrderState.EXT_MODIFY_ACCEPTANCE_NEEDED === row.orderState
    ) {
      orderRecord.externalState = true;
    }

    orderRecord.requestType =
      row.fixingDetails == null || CubiqTS.OrderType.BENCHMARK != row.orderType
        ? OrderCancelType.LIMIT
        : OrderCancelType.BENCHMARK;

    if (withReason) {
      orderRecord.reason = row[COLUMN_ORDER_ERRORS];
    }

    if (
      row != null &&
      row.fixingDetails != null &&
      row.fixingDetails.bmOrderType == CubiqTS.BenchmarkOrderType.PositionOrder
    ) {
      orderRecord.positionOrder = true;
    }

    return orderRecord;
  }

  setParentPopup(parentPopup: GoldenLayoutPopout) {
    this.parentPopout = parentPopup;
    this.parentPopout.setShowDock(false);
  }

  /**
   * Invoked by the close confirmation warning dialog if the
   * user chooses to go ahead and close the window
   */
  public confirmClose(): void {
    this.progressStatus = ProgressStatus.FAILURE;
    this.parentPopout.close();
  }

  /**
   * Callback that determines if this popup should be closed or not
   */
  public onClose(): boolean {
    if (this.progressStatus == ProgressStatus.RUNNING && !this.parentPopout.closeFromLogout) {
      let orderCount: number = this.orderRecords.length;
      let msg: string =
        orderCount == 1 ? "cancel.order.confirm.single" : "cancel.order.confirm.multi";
      let payload: any = {
        messages: [this.translationService.instant(msg)],
        title: "confirm.close.title",
        callback: this.confirmClose.bind(this),
        subMessage: this.translationService.instant("order_entry.dialog.close.subMessage"),
      };
      this.openConfirmDialog(payload);
      return false;
    }

    return true;
  }

  public showColumnSelector(event): void {
    this.columnSelectorService.doColumnSelectorMenu(this, this.gridOptions, event);
  }

  // handle the click of the ag-grid column header and header
  public handleClick(event) {
    if (event.which == 3 && event.target.className.indexOf("ag-header-cell") !== -1) {
      this.showColumnSelector(event);
    } else if (event.which == 3 && event.target.className.indexOf("ag-header-container") !== -1) {
      this.columnSelectorService.doColumnSelectorMenu(this, this.gridOptions, event);
    }
  }

  /**
   *
   */
  protected openConfirmDialog(payload: any): void {
    let bfxDialogData: BfxDialogData = new BfxDialogData(
      BfxDialogCommand.DIALOG_ORDER_CANCEL_CONFIRM_OPEN,
      null,
      null,
      payload,
    );

    if (NativeDesktopSupport.isNativeDesktopContainer()) {
      let wnd: NativeDesktopWindow = NativeDesktopSupport.getWindow(this.element.nativeElement);
      bfxDialogData.body = wnd.getNativeWindow().document.body;
    }

    this.blotterOrderActionService.launchNewDialog(bfxDialogData);
  }

  /**
   * Invoked when the 'Cancel Order' button is pressed. In case the
   * comment is mandatory the comment input will be focussed, otherwise
   * the cancelation execution flow is run.
   * @param event the event that triggered invocation of this method
   * @param commentInput the comment input reference
   */
  public cancelOrders(event: any, commentInput: any): void {
    // logger.out.info("cancel started");
    if (this.mandatoryComment && this.comment.trim().length == 0) {
      this.invalidComment = true;
      commentInput.focus();
    } else {
      let stratMap: Map<string, string> = new Map();
      let orderIds: Map<string, string[]> = new Map([
        ["limitOrderIds", []],
        ["fixingOrderIds", []],
      ]);
      this.orderRecords.forEach((order) => {
        let key = order.requestType === OrderCancelType.LIMIT ? "limitOrderIds" : "fixingOrderIds";

        if (!stratMap.get(order.strategyId)) {
          orderIds.get(key).push(order.orderId);
          stratMap.set(order.strategyId, order.orderId);
        }
      });
      this.hideAllActionButtons();
      this.progressStatus = ProgressStatus.RUNNING;
      let refresh = false;
      this.pendingOrderMap.forEach((orderRecords, orderId, map) => {
        if (!this.orderMap.has(orderId)) {
          map.delete(orderId);
          this.orderMap.set(orderId, orderRecords);
          this.orderRecords.push(...orderRecords);
          refresh = true;
        }
      });
      this.pendingDeletionSet.forEach((orderId, _, set) => {
        set.delete(orderId);
        this.doDeletion(orderId);
        refresh = true;
      });
      if (refresh) {
        this.gridOptions?.api?.setRowData(this.orderRecords);
      }
      this.orderActionService
        .cancelOrders(orderIds, this.comment)
        .then((value: Array<BulkOrderLifeCycleEventImpl>) => {
          // logger.out.info("cancel request complete");
          value.forEach((element) => {
            if (ErrorsImpl.enType == element.encodableType) {
              let rowIds = new Array<any>();

              this.orderRecords.forEach((record: OrderCancelRecord) => {
                record.state = OrderCancelRecordState.FAILED;
                record.orderStatus = STATUS_FAILED;
                this.updateOrderReason(record, element["errorMessages"][0]);
                //
                rowIds.push(record.orderId);
              });

              // redraw
              if (rowIds.length > 0) {
                this.redrawRowsWithIds(rowIds);
              }

              this.fail(this.orderRecords.length);
            } else if (element.events != null && element.events.length > 0) {
              let errorEvents: Array<OrderLifeCycleEvent> = element.events.filter(
                (event: OrderLifeCycleEventImpl) =>
                  event.errors != null && event.errors["errorMessages"].length > 0,
              );
              this.handleOrderLifyeCycleErrorEvents(errorEvents);
              if (element.eventTypeId == FxLifeCycleEventType.REJECTED) {
                let anyInProgress: boolean = this.orderRecords.some(
                  (record: OrderCancelRecord) =>
                    record.state == OrderCancelRecordState.ACCEPTANCE ||
                    record.state == OrderCancelRecordState.IN_PROGRESS,
                );
                if (!anyInProgress) {
                  this.fail(errorEvents.length);
                }
              }
            }
          });

          this.determineActions();
        })
        .catch((reason: any) => {
          logger.out.info(`CANCEL FAIL: %O`, reason);
          this.fail(this.orderRecords.length);
        });
    }
  }

  handleOrderLifyeCycleErrorEvents(errorEvents: OrderLifeCycleEvent[]) {
    let rowIds = new Array<any>();
    errorEvents.forEach((event: OrderLifeCycleEventImpl) => {
      let record: OrderCancelRecord = this.orderMap
        .get(event.orderId)
        .find((order) => order.orderId == event.orderId);
      if (record != null) {
        record.state = OrderCancelRecordState.FAILED;
        record.orderStatus = STATUS_FAILED;
        this.updateOrderReason(record, event.errors["errorMessages"][0]);
        //
        rowIds.push(record.orderId);

        this.doDeletion(record.orderId);
      }
    });
    // redraw
    if (rowIds.length > 0) {
      this.redrawRowsWithIds(rowIds);
    }
    this.cd.markForCheck();
  }

  public validateCommentInput(_event): void {
    this.comment = this.comment.trim();
    this.invalidComment = this.mandatoryComment && this.comment.length == 0;
    this.commentFocused = false;
    if (this.invalidComment) {
      this.externalState = BfxInputControlStateEnum.INVALID;
      this.cd.markForCheck();
    } else {
      this.externalState = BfxInputControlStateEnum.VALID;
    }
  }

  /**
   * Updates order cancel record reason field if error is properly supplied
   */
  protected updateOrderReason(orderRecord: OrderCancelRecord, error: any): void {
    if (typeof error === "string") {
      // error's already been munged by decoder do enough so it parses
      orderRecord.reason = this.convertError({
        errorMessages: [error],
      } as any);
    } else if (error != null && error.length > 1) {
      orderRecord.reason = this.convertError(error);
    }
  }

  /**
   * Creates a translation object with a message as id and
   * parameters as args list from a string
   * @param error the error string as served in ErrorsImpl object
   */
  protected convertError(error: CubiqTS.ErrorsImpl): string {
    let errorObject = error.errorMessages;
    if (errorObject.length) {
      let errorMessage = "";
      errorObject.forEach((errObj: CubiqTS.Message) => {
        let err = JSON.parse(errObj as any);
        if (err && err.id) {
          let translatedMessage = this.translationService.instant(err.id, err.args);
          errorMessage +=
            translatedMessage !== err.id
              ? (errorMessage.length > 0 ? "; " : " ") + translatedMessage
              : "";
        }
      });
      return errorMessage;
    }
    return "-";
  }

  /**
   * Convenience method that sets the final state of the window to success.
   * @param errorCount the number of messages that have failed/rejected
   * @param message the message or default error message if left out
   */
  protected success(): void {
    this.hideAllActionButtons();
    this.progress = 100;
    this.showClose = true;
    this.progressStatus = ProgressStatus.SUCCESS;
    this.cd.markForCheck();
  }

  /**
   * Convenience method that sets the final state of the window to failure.
   * @param errorCount the number of messages that have failed/rejected
   * @param message the message or default error message if left out
   */
  protected fail(errorCount: number, message: string = "cancel.error"): void {
    this.message = message ? this.translationService.instant(message, [errorCount]) : "-";
    this.hideAllActionButtons();
    this.progress = 100;
    this.showClose = true;
    this.progressStatus = ProgressStatus.FAILURE;
    this.cd.markForCheck();
  }

  /**
   * Hides all action buttons placed at the bottom right of the dialog (abort, accept, reject, cancel and close)
   * @param freeze indicates if further button determination should occur
   */
  protected hideAllActionButtons(freeze: boolean = false): void {
    this.freezeButtonUpdates = freeze;
    this.showAbort = this.showAccept = this.showCancel = this.showClose = this.showReject = false;
    this.cd.markForCheck();
  }

  private redrawRowsWithIds(rowIds: Array<string>): void {
    let rows = new Array<any>();
    rowIds.forEach((rowId: string) => {
      let rowData = this.gridOptions.api.getRowNode(rowId);
      if (rowData != null) {
        rows.push(rowData);
      }
    });
    if (rows != null && rows.length >= 1) {
      this.gridOptions.api.redrawRows({ rowNodes: rows });
    }
  }
}
